import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../../lib/api";
import { Reveal } from "../motion";
import { useLang } from "../../lib/i18n";

const CHAPTER_META = [
  { num: "01", imgs: null, img: IMAGES.laser, alt: "Laser Auraskin Gold" },
  { num: "02", imgs: ["/images/electrolyse-1.jpg", "/images/electrolyse-2.jpg"], img: null, alt: "Électrolyse" },
  { num: "03", imgs: null, img: "/images/lashlift-real.jpg", alt: "Réhaussement de cil" },
  { num: "04", imgs: null, img: "/images/browlift-real.jpg", alt: "Brow lift" },
];

export const Services = () => {
  const { t } = useLang();
  const chapters = t("services.chapters");

  return (
    <section id="soins" className="py-28 lg:py-36 bg-cream" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <h2 className="font-display tracking-tight text-4xl sm:text-5xl lg:text-6xl text-espresso max-w-2xl leading-tight">
            {t("services.titleA")} <span className="italic text-taupe">{t("services.titleB")}</span>
          </h2>
        </Reveal>
        <div className="mt-20 space-y-6">
          {CHAPTER_META.map((meta, i) => {
            const c = chapters[i];
            return (
              <Reveal key={meta.num} delay={0.05 * i}>
                <motion.article
                  whileHover={{ y: -4 }}
                  transition={{ duration: 0.4 }}
                  className={`group grid lg:grid-cols-12 gap-0 bg-white border border-taupe/20 rounded-3xl overflow-hidden ${
                    i % 2 === 1 ? "lg:[direction:rtl]" : ""
                  }`}
                  data-testid={`service-chapter-${meta.num}`}
                >
                  <div className="lg:col-span-4 overflow-hidden [direction:ltr]">
                    {meta.imgs ? (
                      <div className="grid grid-cols-2 gap-1 h-60 lg:h-[320px] bg-beige" data-testid={`service-duo-${meta.num}`}>
                        {meta.imgs.map((src, k) => (
                          <img
                            key={k}
                            src={src}
                            alt={`${c.title} — ${k + 1}`}
                            className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                          />
                        ))}
                      </div>
                    ) : (
                      <img
                        src={meta.img}
                        alt={meta.alt}
                        className="w-full h-60 lg:h-[320px] object-cover group-hover:scale-[1.03] transition-transform duration-700"
                      />
                    )}
                  </div>
                  <div className="lg:col-span-8 p-8 lg:p-12 flex flex-col justify-center [direction:ltr]">
                    <span className="font-display text-5xl lg:text-6xl text-outline leading-none">{meta.num}</span>
                    <h3 className="font-display tracking-tight text-3xl lg:text-4xl text-espresso mt-4">
                      {c.title} <span className="italic text-taupe">— {c.accent}</span>
                    </h3>
                    <p className="mt-5 text-base text-espresso/70 font-light leading-relaxed max-w-xl">{c.text}</p>
                    <a
                      href="#rendez-vous"
                      data-testid={`service-booking-${meta.num}`}
                      className="mt-8 inline-flex items-center gap-2 text-[13px] tracking-[0.14em] uppercase text-taupe-dark hover:text-espresso transition-colors duration-300 w-fit"
                    >
                      {t("services.bookCta")}
                      <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" strokeWidth={1.5} />
                    </a>
                  </div>
                </motion.article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
